import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../components/AuthProvider';
import '../../styles/admin/AdminLoginPage.css';
import AdminLoginForm from '../../forms/admin/AdminLoginForm';
import bannerImage from '../../../images/AuthPage/TravelWebKitBase_AdminAuthBanner.png';

const AdminLoginPage = () => {
  const { userLogin, userData } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData && userData.is_admin) {
      navigate('/admin');
    }
  }, [userData, navigate]);

  const MAX_EMAIL_LENGTH = 320;
  const MAX_PASSWORD_LENGTH = 128;

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    if (!email || !password) {
      return 'Please fill out all required fields.';
    }
  
    if (email.length > MAX_EMAIL_LENGTH) {
      return `Email cannot exceed ${MAX_EMAIL_LENGTH} characters.`;
    }
  
    if (!validateEmail(email)) {
      return 'Please enter a valid email address.';
    }
  
    if (password.length > MAX_PASSWORD_LENGTH) {
      return `Password cannot exceed ${MAX_PASSWORD_LENGTH} characters.`;
    }
  
    return '';
  };

  const handleSubmit = async () => {
    setFormSubmitted(true);
    const validationError = validateForm();

    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    setLoading(true);
    setErrorMessage('');

    const data = { email, password };

    try {
      const loginResult = await userLogin(data);

      if (!loginResult.success) {
        setErrorMessage(loginResult.message);
      } else {
        navigate(loginResult.is_admin ? '/admin' : '/user-account/');
      }
    } catch (error) {
      setErrorMessage('Error during login: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin__login-page">

      <div className="auth-page__structure">
        <div className="auth-page__banner">
          <img src={bannerImage} alt="Hero Banner"/>
        </div>
        <div className="auth-page__content">
          <div className="auth-page__right">
            <div className="admin__login-page__card">
              <div className="admin__login-page__intro">
                <h2>Login</h2>
                <p>Don't have an account? <a href="/admin/sign-up">Sign up here</a> to create one.</p>
              </div>
              <AdminLoginForm
                email={email}
                password={password}
                errorMessage={errorMessage}
                loading={loading}
                formSubmitted={formSubmitted}
                handleEmailChange={handleEmailChange}
                handlePasswordChange={handlePasswordChange}
              />
              <div className="admin__login-page__buttons">
                <button className="button" onClick={handleSubmit} disabled={loading || !email || !password}>
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </div>
              <div className="admin__login-page__footer">
                <p>Forgot your password? <a href="/admin/forgot-password">Click here</a> to reset it.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;